import Products from 'merchandise-lib/constants/Product';
import { useProductDetailsForArray } from '../product/useProductDetails';

/**
 * This hook is used to determine if the HubSpot Credits product experience should be shown.
 */
export const useHubSpotCredits = () => {
  var _productDetails$produ;
  const {
    productDetails,
    loading
  } = useProductDetailsForArray({
    productApiNames: [Products.HUBSPOT_CREDITS_COMMITTED, Products.HUBSPOT_CREDITS_COMMITTED_OVERAGE]
  });
  const hasHubSpotCreditsSkus = Object.keys((_productDetails$produ = productDetails === null || productDetails === void 0 ? void 0 : productDetails.productsByName) !== null && _productDetails$produ !== void 0 ? _productDetails$produ : {}).length > 0;
  return {
    showHubSpotCredits: hasHubSpotCreditsSkus,
    loading
  };
};